import Vue from 'vue'
import COMPONENTS_DEFINITION from './components'

for (const [key, value] of Object.entries(COMPONENTS_DEFINITION)) {
  Vue.component(key, value)
}
